
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.47 11.059l5.88 5.878","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13.66 7.14a6.108 6.108 0 01-6.11 6.108 6.108 6.108 0 116.11-6.108z","stroke":"currentColor","stroke-width":"1.5"}})])
          )
        }
      }
    